import React, { memo } from "react";

import colors from "app/colors";
import { useMixpanel } from "modules/providers/mixpanel-provider";
import { MIXPANEL_EVENT_TYPE } from "modules/providers/mixpanel-provider/mixpanel-provider";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import { CheckPlusIcon } from "modules/icons";
import { Button } from "@chakra-ui/react";
import { TASK_DRAFT_ID } from "modules/utils/Constants";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import {
  MessageThreadType,
  TaskPriorityType,
  TaskStatusType,
} from "gql/graphql";

//<OutOfOfficeNote draftId={draftId} />

export const LeftNavCreateTaskButton = () => {
  const { openDrawer } = useOverlay();
  const { track } = useMixpanel();
  const { createDraft } = useMessageThreadDraft({ draftId: TASK_DRAFT_ID });

  const onNewTaskClicked = React.useCallback(async () => {
    await createDraft({
      type: MessageThreadType.Task,
      draftType: "new-thread",
      task: {
        priorityType: TaskPriorityType.None,
        statusType: TaskStatusType.NotStarted,
      },
    });
    openDrawer({ type: DRAWER_TYPE.COMPOSE_TASK });
    track(MIXPANEL_EVENT_TYPE.LINK, {
      "Link Location": "Left Hand Nav",
      "Link Action": "New Task",
    });
  }, [createDraft, openDrawer, track]);

  return (
    <Button
      aria-label="new task"
      variant="hover"
      backgroundColor={colors.greenPrimary}
      color={colors.white}
      size="xs"
      rounded="full"
      iconSpacing={1}
      fontSize={10}
      fontWeight={700}
      onClick={onNewTaskClicked}
      leftIcon={<CheckPlusIcon boxSize={3} fill={colors.white} />}
      px={2}
      w="78px"
    >
      New Task
    </Button>
  );
};

export default memo(LeftNavCreateTaskButton);
